import dayjs from 'dayjs'

import { NewLog } from '../../../../../types'

export const getValidLogs = (logs: NewLog[] | null): NewLog[] =>
  logs?.filter((log) => dayjs(log.date).isValid()) ?? []

export const getLatestLog = (logs: NewLog[] | null): NewLog | null => {
  if (!logs?.length) return null

  return getValidLogs(logs).reduce<NewLog | null>((latest, current) => {
    const currentDate = dayjs(current.date)
    if (!latest) return current

    const latestDate = dayjs(latest.date)
    if (currentDate.isAfter(latestDate)) {
      return current
    }

    return latest
  }, null)
}
